import { configureStore } from '@reduxjs/toolkit'
import authReducer from './authSlice';
import loadingReducer from './loader';
import newsReducer from './newsSlice';
import insightReducer from './insightSlice';
import teamsReducer from './teamsSlice';
import leaderReducer from './leadershipSlice';
import dashboardReducer from './dashboardSlice';


export const store = configureStore({
  reducer: {
    auth: authReducer,
    loader: loadingReducer,
    news: newsReducer,
    insight: insightReducer,
    teams: teamsReducer,
    leader: leaderReducer,
    dashboard: dashboardReducer,


  },
})

export default store;